<template>
  <section class="report modern-report">
    <div class="columns">
      <div class="column" v-if="report.day_stats">
        <day-stats class="mt-5" :day-stats="report.day_stats"/>
      </div>
      <div class="column">
        <b-tabs class="block mt-5 modern-tabs">
          <b-tab-item label="Missing Extracts">
            <missing-extracts :scan-results="report.scan_results"/>
          </b-tab-item>
          <b-tab-item label="All Extracts">
            <scan-results :scan-results="report.scan_results"/>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
    <hr/>
    <p>Data last fetched at: {{ report.run_at.split('T')[1].split('.')[0] }}</p>
  </section>
</template>

<script>
import ScanResults from './ScanResults'
import DayStats from './DayStats'
import MissingExtracts from './MissingExtracts.vue'

export default {
  components: { ScanResults, DayStats, MissingExtracts },
  props: {
    report: Object
  }
}
</script>

<style scoped>
.modern-report {
  background: #f9f9fb;
  border-radius: 14px;
  padding: 2rem 2rem 1rem 2rem;
  margin-top: 2rem;
  box-shadow: 0 2px 16px rgba(0,0,0,0.06);
}
.modern-tabs {
  background: #fff;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
</style>